import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

export const ConfirmationMobile = () => {
    const { t } = useTranslation("confirmation");

    return (
        <section>
            <Typography color="secondary" variant="normal">
                {t("deliveryDetails")}
            </Typography>
        </section>
    );
};
